// extracted by mini-css-extract-plugin
export default {"resetPasswordForm":"styles_resetPasswordForm__Vz6Oi"};